<!--begin::Subheader-->
<div class="subheader py-2 pb-1 pt-1" id="kt_subheader">
    <div class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap container-fluid">
        <div class="d-flex align-items-center flex-wrap mr-1">
            <ng-container *ngIf="subheaderMobileToggle">
                <button class="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none" id="kt_subheader_mobile_toggle">
                    <span></span>
                </button>
            </ng-container>

            <div class="d-flex flex-column">
                <ng-container>
                    <h2 class="text-white font-weight-bold my-2 mr-5" style="font-size: 30px">
                        <a href="javascript:void(0)" class="inactive-icon">
                            <img [src]="imgSrc" alt="" (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()" />
                        </a>
                        <ng-container>
                            {{ headerData.displayText }}
                        </ng-container>
                    </h2>
                </ng-container>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <div class="activity_header_wrapper d-flex align-items-center justify-content-end w-100">
                <span class="activity_title">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.ORGANIZATION_NAME' | transloco }}</span>
                <span class="section-data">{{ currentOrganizationName }}</span>
                <span class="activity_title">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.INSTANCE_NAME' | transloco }}</span>
                <span class="section-data">{{ currentInstanceName }}</span>
                <span class="activity_title" *ngIf="currentAssetType">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.ASSET_TYPE' | transloco }}</span>
                <span class="section-data" *ngIf="currentAssetType">{{ currentAssetType }}</span>
            </div>

            <div class="d-flex align-items-center">
                <div
                    class="dropdown dropdown-inline ml-2"
                    data-toggle="tooltip"
                    title="Quick actions"
                    data-placement="left"
                    placement="bottom-right"
                    ngbDropdown
                >
                    <div class="informate-button">
                        <app-matrix-add-or-create class="informate-matrix" [calcOutput]="calcOutput" *ngIf="hideButtons === true"> </app-matrix-add-or-create>
                        <div class="mr-8 ml-5 position-relative" *ngIf="hideButtons === true" s>
                            <app-reports-dropdown [calculationResult]="calcOutput"></app-reports-dropdown>
                        </div>
                        <app-matrix-create
                            (newCreatedMatrix)="newMatrixCreated($event)"
                            *ngIf="headerData?.displayTitle == 'Joint Matrics'"
                            style="padding-right: 15px"
                        ></app-matrix-create>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
